export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/articles_blog_posts.baf9c0b.svg";